import {
  CREATEOFFER_REQUEST,
  CREATEOFFER_SUCCESS,
  CREATEOFFER_FAIL,
  DELETEOFFER_REQUEST,
  DELETEOFFER_SUCCESS,
  DELETEOFFER_FAIL,
  GETOFFER_REQUEST,
  GETOFFER_SUCCESS,
  GETOFFER_FAIL,
  UPDATEOFFER_REQUEST,
  UPDATEOFFER_SUCCESS,
  UPDATEOFFER_FAIL,
} from "../actions/types";

const initialState = {
  offerList: [],
  offerSaveStatus: { loading: false, success: false, error: null },
  offerUpdateStatus: { loading: false, success: false, error: null },
  offerDeleteStatus: { loading: false, success: false, error: null },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // Create Offer
    case CREATEOFFER_REQUEST:
      return {
        ...state,
        offerSaveStatus: { loading: true, success: false, error: null },
      };
    case CREATEOFFER_SUCCESS:
      return {
        ...state,
        loading: false,
        offer: action.payload, // Save the created offer
        error: null,
      };

    case CREATEOFFER_FAIL:
      return {
        ...state,
        offerSaveStatus: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };

    // Get Offers
    case GETOFFER_REQUEST:
      return {
        ...state,
        // optionally, you can add a loading state here
      };
    case GETOFFER_SUCCESS:
      return {
        ...state,
        offerList: action.payload.data || action.payload, // depends on API response shape
      };
    case GETOFFER_FAIL:
      return {
        ...state,
        // optionally handle error state for get offers
      };

    // Update Offer
    case UPDATEOFFER_REQUEST:
      return {
        ...state,
        offerUpdateStatus: { loading: true, success: false, error: null },
      };
    case UPDATEOFFER_SUCCESS:
      return {
        ...state,
        offerUpdateStatus: { loading: false, success: true, error: null },
      };
    case UPDATEOFFER_FAIL:
      return {
        ...state,
        offerUpdateStatus: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };

    // Delete Offer
    case DELETEOFFER_REQUEST:
      return {
        ...state,
        offerDeleteStatus: { loading: true, success: false, error: null },
      };

    case DELETEOFFER_SUCCESS:
      return {
        ...state,
        offerList: state.offerList.filter(
          (offer) => offer.id !== action.payload.id
        ), // Use offerList
        offerDeleteStatus: { loading: false, success: true, error: null },
      };

    case DELETEOFFER_FAIL:
      return {
        ...state,
        offerDeleteStatus: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };

    default:
      return state; // Return current state if action type does not match
  }
}
